<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { verifySettingUnsupportedFWVersion } from 'src/helpers/firmware_helpers';
	import DeviceSettingsUnsupportedFw from '../../DevicesSettings/DeviceSettingsUnsupportedFW.svelte';
	//Design system components
	import { Button, Container, Modal, Text, Icon } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';

	export let device: Device, settings;

	let waitingRorRequest = false;
	let resetCountersModal = false;

	const sentRequests = async () => {
		waitingRorRequest = true;
		const res: SettingRequest = await gen2Request(device, 'Input.ResetCounters', { id: 2 });
		if (res?.isok) resetCountersModal = false;
		onSettingsResponse(res, device);
		waitingRorRequest = false;
	};

	const unsupportedFW = verifySettingUnsupportedFWVersion(device, settings, '1.2.0');
</script>

{#if unsupportedFW}
	<DeviceSettingsUnsupportedFw {device} values={unsupportedFW} />
{:else}
	<Text styleType="body-small" class="mb-s"
		>{$format('sub_settings_title_input_counter_reset_info', {
			default: 'This will reset all input readings to 0',
		})}</Text
	>
	<Button size="m" width="full" on:click={() => (resetCountersModal = true)}
		>{capFirstChar($format('button_reset', { default: 'reset' }))}</Button
	>
{/if}

{#if resetCountersModal}
	<Modal
		showModal={resetCountersModal}
		on:close={() => (resetCountersModal = false)}
		title={`${capFirstChar(
			$format('button_reset', { default: 'reset' }),
		)} ${$format('input_counter_title', { default: 'Input Counter' })}?`}
	>
		<svelte:fragment slot="content">
			<Container padding="0">
				<div class="d-flex flex-direction-column align-items-center">
					<Icon icon="text-danger fak fa-light-factory-reset" size="xxl" />
					<Text class="mt-xs width-full">
						{$format('sub_settings_title_input_counter_reset_confirm', {
							default:
								'Are you sure you want to reset your input counter? All accumulated data in the component will be lost!',
						})}
					</Text>
				</div>
			</Container>
		</svelte:fragment>
		<div class="d-flex justify-content-end" slot="footer">
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				responsiveSize={{
					sm: 'm',
				}}
				variant="secondary"
				on:click={() => (resetCountersModal = false)}
			>
				{$format('button_cancel', { default: 'Cancel' })}
			</Button>
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
				variant="danger"
				responsiveSize={{
					sm: 'm',
				}}
				loading={waitingRorRequest}
				disabled={waitingRorRequest}
				on:click={sentRequests}
			>
				{capFirstChar($format('button_reset', { default: 'reset' }))}
			</Button>
		</div>
	</Modal>
{/if}
